// extracted by mini-css-extract-plugin
export default {"btns":"ReviewPage_btns__lzrTU","root":"ReviewPage_root__0cbun","info":"ReviewPage_info__hu3p2","edit":"ReviewPage_edit__Wo7qI"};